/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */

/* tslint:disable:use-input-property-decorator */

import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Output,
    EventEmitter
} from '@angular/core';





import { NestedOptionHost } from '../../core/nested-option';
import { DxoCalendarOptions } from './base/calendar-options';


@Component({
    selector: 'dxo-calendar-options',
    template: '',
    styles: [''],
    providers: [NestedOptionHost],
    inputs: [
        'accessKey',
        'activeStateEnabled',
        'cellTemplate',
        'dateSerializationFormat',
        'disabled',
        'disabledDates',
        'elementAttr',
        'firstDayOfWeek',
        'focusStateEnabled',
        'height',
        'hint',
        'hoverStateEnabled',
        'isValid',
        'max',
        'maxZoomLevel',
        'min',
        'minZoomLevel',
        'name',
        'onDisposing',
        'onInitialized',
        'onOptionChanged',
        'onValueChanged',
        'readOnly',
        'rtlEnabled',
        'showTodayButton',
        'tabIndex',
        'validationError',
        'validationMessageMode',
        'value',
        'visible',
        'width',
        'zoomLevel'
    ]
})
export class DxoCalendarOptionsComponent extends DxoCalendarOptions {

    /**
     * A handler for the valueChange event.
     */
    @Output() valueChange: EventEmitter<Date | number | string>;

    /**
     * A handler for the zoomLevelChange event.
     */
    @Output() zoomLevelChange: EventEmitter<string>;
    protected get _optionPath() {
        return 'calendarOptions';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();

        this._createEventEmitters([
            { emit: 'valueChange' },
            { emit: 'zoomLevelChange' }
        ]);

        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxoCalendarOptionsComponent
  ],
  exports: [
    DxoCalendarOptionsComponent
  ],
})
export class DxoCalendarOptionsModule { }
